<template>
  <a-result
    v-show="loginBtn"
    status="warning"
    title="登录异常"
    sub-title="检测到您在短时间内多次登录，请检查是否存在多个终端（浏览器或者飞书客户端）同时登录的情况"
  >
    <template #extra>
      <a-button type="primary" @click="loginJumpFeishu">继续登录</a-button>
    </template>
  </a-result>
</template>

<script>
import { larkLogin } from '@/api/user';
import { getAppId } from '@/utils/utils';
import moment from 'moment';

export default {
  data() {
    let history = [];
    try {
      let allHistory = JSON.parse(localStorage.getItem('loginHistory'));
      history = allHistory.filter(item => {
        return moment().diff(moment(item), 'minutes') < 10;
      });
    } catch (e) {
      localStorage.removeItem('loginHistory');
    }
    return {
      appId: getAppId(),
      loginHistory: history
    };
  },
  computed: {
    loginBtn() {
      return this.loginHistory.length > 1 && !this.$route.query.code;
    }
  },
  methods: {
    loginJumpFeishu() {
      let redirect = encodeURIComponent(this.$route.query.redirect);
      let redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.host}/login?redirect=${redirect}`);
      window.location.href = `${window.location.protocol}//open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${redirect_uri}&app_id=${this.appId}`;
    },
    loginWithCode() {
      larkLogin({
        code: this.$route.query.code,
        type: 1
      }).then(res => {
        if (res.code === 200) {
          this.$store.dispatch('user/setToken', res.data);
          let redirect = decodeURIComponent(this.$route.query.redirect);
          this.$router.replace(redirect);
          this.loginHistory.push(moment().format('YYYY-MM-DD HH:mm:ss'));
          localStorage.setItem('loginHistory', JSON.stringify(this.loginHistory));
        } else {
          setTimeout(() => {
            this.loginJumpFeishu();
          }, 5000);
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.loginWithCode();
    } else if (!this.loginBtn) {
      this.loginJumpFeishu();
    }
  }
};
</script>
